import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';

const OfflineOverlay = ({ open }: { open: boolean }) => {
  if (!open) return null;

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      hideBackdrop={false}
      PaperProps={{
        sx: {
          borderRadius: '14px',
          boxShadow: 4,                 
          border: '1px solid #d0d7de', 
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0,0,0,0.25)',
          backdropFilter: 'blur(2px)',
        },
      }}
      sx={{
        '& .MuiDialog-container .MuiPaper-root': {
          width: '100%',
          maxWidth: '420px',
        },
      }}
    >
      <DialogContent
        sx={{
          px: 4,
          py: 3,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2} 
        >
          {/* Icon */}
          <WifiOffIcon
            sx={{
              fontSize: 44,
              color: '#ff0000',
            }}
          />

          {/* Title */}
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#134157',
              textAlign: 'center',
            }}
          >
            No Internet Connection
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: '13px',
              color: '#134157',
              textAlign: 'center',
              lineHeight: 1.5,
              maxWidth: '90%',
            }}
          >
            You are offline. Editing and saving are temporarily disabled until
            your internet connection is restored.
          </Typography>

          {/* Loader + status */}
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            mt={1.5} 
          >
            <CircularProgress size={16} />
            <Typography
              sx={{
                fontSize: '12px',
                color: '#134157', 
                fontWeight: 600,
              }}
            >
              Reconnecting…
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default OfflineOverlay;
